import { render, staticRenderFns } from "./AddIncomeDetails.vue?vue&type=template&id=3c3529c2"
import script from "./AddIncomeDetails.vue?vue&type=script&lang=js"
export * from "./AddIncomeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports